


























import { Vue, Component, Prop } from "vue-property-decorator";
import { SvgIcon } from "@brankas/web-ui";

interface IBreadcrumbItem {
  label: string;
  action: () => void;
}

@Component({
  components: {
    SvgIcon,
  },
})
export default class CustomBreadcrumb extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: IBreadcrumbItem[];
}
